import { createGlobalStyle } from 'styled-components';

import theme from './theme';

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: 0;
    font: 1rem Source Sans Pro, sans-serif;
  }
  
  html {
    font-size: 62.5%;
  }
  
  html,
  body {
    height: 100vh;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
  }

  body {
    font-size: 1.6rem;
    background-color: ${theme.colors.WHITE};
  }
  body > #root > div {
    height: calc(100vh - 6.7rem);
  }
  
  main {
    padding: 5rem 3.5rem 2.4rem;

    @media only screen and (min-width: 768px) {
      max-width: 61.6rem;

      margin: 0 auto;
    }
  }
`;
